import React, { useEffect } from 'react';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../../../components/SelectTwo';
import { Depot } from '../../../../../../../app/models/Depot';
import { WarehouseQuoteStorageDataForm } from '../../../../../../../app/models/WareHouseQuoteStorage';
import useHandleErrorFields from '../../../../../../../hooks/useHandleErrorFields';

interface Props {
    warehouseStorageform: WarehouseQuoteStorageDataForm;
    setWarehouseStorageform: (warehouseQuoteform: WarehouseQuoteStorageDataForm) => void;
    disableUpdate?: boolean;
    isEdit?: boolean;
    depots: Depot[];
    errorFields?: any;
}

const WarehouseQuoteStorageForm = ({
    warehouseStorageform,
    setWarehouseStorageform,
    disableUpdate = false,
    isEdit = false,
    depots,
    errorFields,
}: Props) => {
  
    useEffect(() => {
      setErrors(errorFields);
    }, [errorFields]);
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (!setWarehouseStorageform) return;
        const { name, value } = e.target;
        setWarehouseStorageform({ ...warehouseStorageform, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        if (!setWarehouseStorageform) return;
        setWarehouseStorageform({ ...warehouseStorageform, [name]: value });
    };
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    return (
        <>
                <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Almacén</label>
                <div className="col-md-9">
                    <SelectTwo
                    name="depot_id"
                    id="depot_id"
                    inputValue={warehouseStorageform.depot_id}
                    options={SelectTwoMapperOptions(depots, 'id', ['name'])}
                    hasError={fieldHasError('depot_id') !== ''}
                    onChange={v => handleChangeSelectTwo('depot_id', v.value)}
                    placeholder="Seleccione un almacén"
                        
                    onFocus={() => onFocusRemove('depot_id')}

                    disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('depot_id')}
                    </div>
                </div>
                </div>


            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Días libres</label>
                <div className="col-md-9">
                    <input
                        type="number"
                        className="form-control"
                        name="free_days"
                        value={warehouseStorageform.free_days ?? ''}
                        onChange={handleChange}
                        placeholder="Cantidad de días sin cobro"
                        // disabled={disableUpdate}
                    />
                </div>
                <div className="invalid-feedback">{fieldErrorMessage('free_days')}</div>

            </div>
        </>
    );
};

export default WarehouseQuoteStorageForm;
